import { useState } from "react";

import { useTranslation } from "react-i18next";

import PriceFormat from "../../utils/priceFormat";
import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";

/** Offer part of the money back and the buyer keeps the item. */
export default function PartialOfferPanel({ detail, onConfirm, onCancel, busy }: ReturnActionPanelProps) {
  const { t } = useTranslation("returns");
  const of = detail.estimatedRefund?.total ?? 0;
  const [amountText, setAmountText] = useState(of > 0 ? (Math.round(of * 50) / 100).toFixed(2) : "");
  const amount = Number(amountText);
  const valid = Number.isFinite(amount) && amount > 0 && (of === 0 || amount < of);
  const pct = of > 0 && valid ? Math.round((amount / of) * 100) : null;

  return (
    <ActionPanelFrame
      kind="partial_offer"
      detail={detail}
      canConfirm={valid}
      confirmLabel={t("Confirm offer – send to eBay")}
      templateExtras={valid ? { refund_amount: PriceFormat(amount) } : undefined}
      onConfirm={(message) => onConfirm({ message, amount: Math.round(amount * 100) / 100 })}
      onCancel={onCancel}
      busy={busy}
    >
      <div className="grid grid-cols-2 gap-2 text-[12px]">
        <label className="flex flex-col gap-0.5 text-gray-700">
          {t("Offer")}
          <span className="flex items-center overflow-hidden rounded-lg border border-gray-300">
            <span className="flex items-center self-stretch border-r border-gray-200 px-2.5 text-gray-500">£</span>
            <input type="number" min="0.01" step="0.01" value={amountText} onChange={(e) => setAmountText(e.target.value)} aria-label={t("Offer amount")} disabled={busy} className="w-full border-0 px-2.5 py-1.5 text-[13px] font-semibold focus:ring-0" />
          </span>
        </label>
        <div className="flex flex-col gap-0.5 text-gray-700">
          {t("Of")}
          <span className="py-1.5 font-semibold text-gray-900">
            {PriceFormat(of)}
            {pct !== null && ` · ${pct}%`}
          </span>
        </div>
      </div>
      {!valid && amountText && <span className="text-[11px] text-red-700">{t("The offer has to be more than nothing and less than the full refund.")}</span>}
    </ActionPanelFrame>
  );
}
